import { ExclamationCircle } from '@alefeducation/ui-elements-library-icons';
import { Text } from '@alefeducation/ui-elements-library-core';
import React from 'react';
import styled from 'styled-components';

const StyledMessage = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme: { space } }) => `${space[8]}px`};
`;

type Props = {
  messageText: string;
};

const InfoMessage = ({ messageText }: Props) => {
  return (
    <StyledMessage>
      <ExclamationCircle color="primary.60" height="14" width="14" />
      <Text
        data-testid={'status-message'}
        variant="body-large"
        weight="light"
        color="primary.60"
      >
        {messageText}
      </Text>
    </StyledMessage>
  );
};

export default InfoMessage;
